module.exports = __webpack_public_path__ + "static/img/4.3e4fc3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/4.png
// module id = 6Oc/
// module chunks = 0